import { createFileRoute } from "@tanstack/react-router";
import RegexGeneratorPage from "@/pages/RegexGeneratorPage";

export const Route = createFileRoute("/tools/regex-generator")({
  component: RegexGeneratorPage,
});
